module.exports = __webpack_public_path__ + "img/4.f0355f63.png";